import React from "react";
import { H2, H3, Paragraph } from "BaseComponents/Text";
import {
  ServiceWrapper,
  ServiceInnerWrapper,
  ServiceCardWrapper,
  ImageWrapper,
  ImageWrapperLink,
} from "./components";
import { HeaderLinkStyle as ServiceLink } from "BaseComponents/Link/BaseLink";
import useBreakpoint from "Hooks/useBreakpoint";
import { getResponsiveImage } from "Helpers/ImageHelper";
import { GetTextColor } from "Helpers/ColorHelper";
import { useGlobal } from "reactn";
import LazyImage from "../../framework/lazy/LazyImage";

const CardsToShow = (Concepts, ParentLinkName = LinkName, CenterContent) => {
  const [theme] = useGlobal("theme");
  return Concepts.map((card, index) => {
    const { Link, LinkName, Heading, Preamble, ResponsiveImage } = card;
    const Image = getResponsiveImage(ResponsiveImage);
    const alt = ResponsiveImage.Alt;

    return (
      <ServiceCardWrapper
        key={`concept-card-${index}`}
        centerContent={CenterContent}
        removePadding={true}
        index={index}
      >
        <ServiceCardWrapper
          centerContent={CenterContent}
          bottomLine={true}
          index={index}
        >
          <ImageWrapperLink href={Link} Heading={Heading}>
            <ImageWrapper alignSelf="center">
              <LazyImage source={Image} alt={alt} />
            </ImageWrapper>
          </ImageWrapperLink>
          <H3
            margin="2rem 0 0.5rem 0"
            fontWeight="600"
            mobileFontSize="22px !important"
            forceLargeFontSize="22px"
            whiteSpace="break-spaces"
            textAlign="center"
          >
            {Heading}
          </H3>
          <Paragraph display="block" left>
            {Preamble}
          </Paragraph>
          {Link !== undefined && Link !== "" && (
            <ServiceLink
              inverted
              width="fit-content"
              margin="1rem 0 0 0"
              href={Link}
              text={LinkName ?? ParentLinkName}
              ariaLabel={LinkName ?? ParentLinkName}
              textTransform="uppercase"
              color={theme.colors.primary}
              textAlign="center"
              forceFontSize="18px"
            >
              <span>{LinkName ?? ParentLinkName}</span>
            </ServiceLink>
          )}
        </ServiceCardWrapper>
      </ServiceCardWrapper>
    );
  });
};

export const Services = ({ Heading, Concepts, LinkName, CenterContent }) => {
  const [theme] = useGlobal("theme");
  return (
    <ServiceWrapper>
      <H2
        textTransform="uppercase"
        inline
        margin="0 0 4rem 0"
        marginsmall="0 0 2rem 0"
        fontWeight="600"
        color={theme.colors.primary}
      >
        {Heading}
      </H2>
      {Concepts.length > 0 && (
        <ServiceInnerWrapper
          justify={Concepts.length > 3 ? "space-between" : "flex-start"}
        >
          {CardsToShow(Concepts, LinkName, CenterContent)}
        </ServiceInnerWrapper>
      )}
    </ServiceWrapper>
  );
};
